import {assert} from 'assert-ts';
import type {PartValueModifier} from 'schemaDefinition/types';

/*
  When a winner is edited, we have to remove the id to inform backend that there is a change on this winner.
  Helps them so they don't have to outbox all winners always.
 */
export const winnerValueModifier: PartValueModifier = ({
  value,
  valuePath,
  oldValue,
}) => {
  assert(
    valuePath.startsWith('winners['),
    'winnerValueModifier: valuePart must start with winners[',
    {valuePath},
  );

  // Ignore change to same value.
  if (value === oldValue) {
    return {value};
  }

  const idValuePath = `${valuePath.substring(0, valuePath.indexOf('.'))}.id`;

  return {
    value,
    sideEffects: [
      {
        valuePath: idValuePath,
        value: null,
      },
    ],
  };
};
